import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainButton from "../../../commonComponents/MainButton";
import { ReactComponent as MagnifiyingGlass } from "../../../assets/navbar/MagnifyingGlass.svg";
import { ReactComponent as BackArrow } from "../../../assets/navbar/BackArrow.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setComHistory, setComHistoryFiltred } from "../../../redux/actions/comActions";

function ReportChoiceTopBar({ all_history, set_all_history_filterer, set_rand_update, sub_type }) {
  const [selected, setSelected] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setComHistoryFiltred_rd = (data) => dispatch(setComHistoryFiltred(data));
  // const all_history = useSelector((state) => (state.com.all_history ? state.com.all_history : null));

  function handleOnChangeSearchBar(value) {
    set_all_history_filterer(value.target.value);
    const filtred = Object.entries(all_history)
      .filter((x) => x[1].product_name.toLowerCase().includes(value.target.value))
      .reduce((acc, cur) => {
        acc[cur[0]] = cur[1];
        return acc;
      }, {});
    setComHistoryFiltred_rd(filtred);
    set_rand_update(Math.random());
  }

  function handleOnChangeStatusFilter(value) {
    let filtred;
    switch (value) {
      case 1:
        filtred = all_history;
        break;
      case 2:
        filtred = Object.entries(all_history)
          .filter((x) => x[1].type === "analyse")
          .reduce((acc, cur) => {
            acc[cur[0]] = cur[1];
            return acc;
          }, {});
        break;
      case 3:
        filtred = Object.entries(all_history)
          .filter((x) => x[1].type === "optimisation")
          .reduce((acc, cur) => {
            acc[cur[0]] = cur[1];
            return acc;
          }, {});
        break;
      default:
        return;
    }
    setComHistoryFiltred_rd(filtred);
    set_rand_update(Math.random());
  }

  return (
    <>
      <div className="ml-[25px] h-[70px] bg-white flex items-center border-[#BEC4C]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <Link to="/Com">
            <BackArrow />
          </Link>
          <div className="ml-10 flex items-center  justify-between">
            <p className="font-Poppins-SemiBold text-lg inline">Communiquer - Rapport automatique</p>
          </div>
        </div>
      </div>

      <div className="flex h-[80px] mt-10 bg-white mr-[95px] ml-[150px] items-center justify-between rounded-lg">
        <div className="flex flex-col items-center justify-center max-w-xl ml-[30px]">
          <ul className="flex space-x-2">
            <li>
              <a
                href="#"
                onClick={() => {
                  setSelected(1);
                  handleOnChangeStatusFilter(1);
                }}
                className={` ${selected === 1 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
              >
                Tous
              </a>
            </li>
            {sub_type !== "kit eco-score" && (
              <>
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      setSelected(2);
                      handleOnChangeStatusFilter(2);
                    }}
                    className={`${selected === 2 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
                  >
                    Analyse
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={() => {
                      setSelected(3);
                      handleOnChangeStatusFilter(3);
                    }}
                    className={` ${selected === 3 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
                  >
                    Optimisation
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>

        <div className="flex ml-[120px]">
          <input
            style={{ padding: 10 }}
            onChange={(value) => {
              handleOnChangeSearchBar(value);
            }}
            className="w-[400px] mx-10 rounded-md bg-[#F8FAFB] font-PoppinsLignt text-sm h-[35px]"
            type="text"
            placeholder="Rechercher le nom d'un produit..."
          />
        </div>

        <div className={"text-xs h-[35px] w-[200px] rounded-lg text-white font-Poppins-SemiBold flex justify-evenly items-center mr-[20px]"}>
          {/* <MainButton callback={() => navigate("/AnalysisProduceChoice")} title={"Créer une analyse"} styleWind={"text-xs px-[10px]"} /> */}
        </div>
      </div>
    </>
  );
}

export default ReportChoiceTopBar;
